export default __webpack_public_path__ + "static/media/social-media.53a26ac7.gif";